import axios from 'axios';
import { getPocketBaseUtils } from './pocketbaseUtils';

class PredictionsApiUtils {
    constructor(predictionsApiConfig) {
        if (predictionsApiConfig) {
            this.baseUrl = predictionsApiConfig.baseUrl;
        }
    }

    getLeagues = async () => {
        const url = this._buildUrl(_routes.GET_LEAGUES);
        const apiResponse = await this._getRequest(url);
        return apiResponse.data.leagues;
    }

    getUserGuilds = async (userId) => {
        const url = `${this._buildUrl(_routes.GET_USER_GUILDS)}/${userId}`;
        const apiResponse = await this._getRequest(url);
        return apiResponse.data.user_guilds;
    }

    getUpcomingFixtures = async (leagueId, limit) => {
        const params = { "league_id": leagueId, "limit": limit };
        const url = this._buildUrl(_routes.GET_UPCOMING_FIXTURES, params);
        const apiResponse = await this._getRequest(url, params);
        return apiResponse.data;
    }

    getUpcomingFixturesByDate = async (leagueId, limit) => {
        const apiResponse = await this.getUpcomingFixtures(leagueId, limit);
        let fixturesByDate = {}
    
        for (const fixture of apiResponse.fixtures) {
            let fixtureDate = new Date(fixture.date).toDateString();
            (fixturesByDate[fixtureDate] ||= []).push(fixture);
        }

        return fixturesByDate;
    }

    getStatus = async () => {
        const url = this._buildUrl(_routes.GET_STATUS);
        const apiResponse = await this._getRequest(url);
        return apiResponse.data;
    }

    getFixtureRefreshTime = async () => {
        const apiResponse = await this.getStatus();
        return new Date(apiResponse.stats.last_refresh_times.fixtures);
    }

    getLeaderboard = async (leagueId, guildId, startDate, endDate) => {
        const params = { "league_id": leagueId, "guild_id": guildId };
        if (startDate) { params["start_date"] = startDate; }
        if (endDate) { params["end_date"] = endDate; }
        const url = this._buildUrl(_routes.GET_LEADERBOARD, params);
        const apiResponse = await this._getRequest(url);
        return apiResponse.data;
    }

    getLeaderboardChartData = async (leagueId, guildId, startDate, endDate) => {
        const params = { "league_id": leagueId, "guild_id": guildId };
        if (startDate) { params["start_date"] = startDate; }
        if (endDate) { params["end_date"] = endDate; }
        const url = this._buildUrl(_routes.GET_LEADERBOARD_CHART, params);
        const apiResponse = await this._getRequest(url);
        return apiResponse.data;
    }

    getBotGuilds = async () => {
        const url = this._buildUrl(_routes.GET_GUILDS);
        const apiResponse = await this._getRequest(url);
        return apiResponse.data;
    }

    getPredictions = async (guildId, fixtureIds) => {
        const params = { "user_id": getPocketBaseUtils().getAuthenticatedUser().discordId, "guild_id": guildId, "fixture_id": fixtureIds };
        const url = this._buildUrl(_routes.GET_PREDICTIONS_BY_FIXTURES, params);
        const apiResponse = await this._getRequest(url);
        return apiResponse.data;
    }

    getAllPredictions = async (leagueId, guildId, startDate, endDate) => {
        const params = { "guild_id": guildId, "league_id": leagueId  };
        if (startDate) { params["start_date"] = startDate; }
        if (endDate) { params["end_date"] = endDate; }
        const url = this._buildUrl(_routes.GET_PREDICTIONS_BY_DATE, params);
        const apiResponse = await this._getRequest(url);
        return apiResponse.data;

    }

    

    setPredictions = async (predictionData) => {
        const url = this._buildUrl(_routes.SET_PREDICTIONS);
        const apiResponse = await this._postRequest(url, predictionData);
        return apiResponse.data;
    }

    _getRequest = async (url) => {
        return axios.get(url, {
            headers: {
                "Authorization": `Bearer ${getPocketBaseUtils().getAuthToken()}`
            }
        });
    }

    _postRequest = async (url, data) => {
        return axios.post(url, data, {
            headers: {
                "Authorization": `Bearer ${getPocketBaseUtils().getAuthToken()}`
            }
        });
    }

    _buildUrl = (route, params) => {
        let url = new URL(`${this.baseUrl}${route}`);
        let urlParams = new URLSearchParams();

        if (params) {
            for (const [name, value] of Object.entries(params)) {
                if (Array.isArray(value)) {
                    for (const item of value) {
                        urlParams.append(name, item);
                    }
                } else {
                    urlParams.append(name, value);
                }
            }
            return `${url.toString()}?${urlParams.toString()}`
        }

        return url.toString();
    }
}

let _predictionsApiUtils = null;
const _routes = {
    GET_STATUS: "/admin/status",
    GET_LEADERBOARD: "/predictions/leaderboard",
    GET_LEADERBOARD_CHART: "/predictions/leaderboard/chart",
    GET_GUILDS: "/statistics/guilds",
    GET_LEAGUES: "/statistics/leagues", 
    GET_USER_GUILDS: "/statistics/user/guilds",
    GET_UPCOMING_FIXTURES: "/statistics/fixtures/upcoming",
    GET_PREDICTIONS_BY_FIXTURES: "/predictions/by_fixtures",
    GET_PREDICTIONS_BY_DATE: "/predictions/by_date",
    SET_PREDICTIONS: "/predictions/",
}

const initPredictionsApiUtils = (config) => {
    if (!_predictionsApiUtils) {
        _predictionsApiUtils = new PredictionsApiUtils(config);
    }
    return _predictionsApiUtils;
}

const getPredictionsApiUtils = () => {
    return _predictionsApiUtils;
}

export { initPredictionsApiUtils, getPredictionsApiUtils };